import React from 'react';
import PlantsChart from '../../../../../../components/Highcharts/LineCharts/PlantsChart/PlantsChart';

const PlantsChartTab = ({
  sectorId, farmId,
}: { sectorId: string, farmId: string }) => (
  <>
    <PlantsChart
      chartView="graphs"
      sectorId={sectorId}
      farmId={farmId}
      height={400}
    />
  </>
);

export default PlantsChartTab;
